///include /assets/js/app/p/checkout.js
class CheckoutPaystack extends CheckoutDriver {
    get requiresImmediateSelection() {
        return false
    }
}

CheckoutDriver.byName.paystack = CheckoutPaystack
